import styles from "./welcome.module.css";
import "../../assets/fonts/fonts.css"
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/Routes/Routes";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";


const Welcome = () => {
  const navigate = useNavigate();
  const [isGeneratedLimit, setIsGeneratedLimit] = useState(false);
  const usedAttemptsDaily = localStorage.getItem("generatedAttemptsDaily");
  const btnRef = useRef(null);


  useEffect(() => {
    scrollToTop();
  }, []);


  const redirectToGenerationType = async () => {
    await animateButtonPress(btnRef, styles.pressed);

    navigate(Routes.generationType);
  };


  useEffect(() => {
    if (usedAttemptsDaily === "5") {
      setIsGeneratedLimit(!isGeneratedLimit);
    }
  }, [usedAttemptsDaily]);


  return (
    <section className={styles["section_wrapper"]}>
      <div className={styles["welcome__page"]}>
        <img
          className={
            !isGeneratedLimit ?
              `${styles["welcome__logo"]}`
              :
              `${styles["welcome__logo-warning"]}`
          }
          src={
            !isGeneratedLimit ?
              require("./img/img-welcome_page.png")
              :
              require("./img/img-welcome_page-out_of_limit.png")
          }
          alt="welcome__logo"/>
        <div
          className={
            isGeneratedLimit ?
              `${styles["welcome__page_text-warning"]}`
              :
              `${styles["welcome__page_text"]}`
          }>
          {isGeneratedLimit ? texts.welcome['title-warning'] : texts.welcome['title']}
        </div>
        <button ref={btnRef}
                className={
                  !isGeneratedLimit ?
                    `${styles['welcome__page_button']}`
                    : `${styles['welcome__page_button-disabled']}`
                }
                onClick={redirectToGenerationType}>
          {texts.welcome["button"]}
        </button>
      </div>
    </section>
  );
};

export default Welcome;
